import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import PnpMachineStatus from "./pnp-machine-status.view";
import PnpProductionCount from './pnp-production-count.view'
import PnpMachineSpoilage from "./pnp-machine-spoilage.view";
import PnpMachineDowntime from "./pnp-machine-downtime.view";
import FactoryFilter from "../Components/Filter/factory-dropdown.component";
import { isEmpty } from "lodash";
const PickAndPlace = () => {
  const { t } = useTranslation();
  const isRange = useRef(false);
  let [loading, setLoading] = useState(true);
  let [factory, setFactory] = useState(null);
  let [machine, setMachine] = useState(null);
  let [shift, setShift] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const updateFactory = (factoryChanged) => {
    setFactory(factoryChanged);
    updateLoading(factoryChanged, null, null, null, null);
  };
  const updateMachine = (machineChanged) => {
    setMachine(machineChanged);
    updateLoading(factory, machineChanged, shift, startDate, endDate);
  };
  const updateShift = (shiftChanged) => {
    setShift(shiftChanged);
    updateLoading(factory, machine, shiftChanged, startDate, endDate);
  };
  const updateLoading = (tempFactory, tempMachine, tempShift, from, to) => {
    if(!isEmpty(tempFactory) && !isEmpty(tempMachine) && !isEmpty(tempShift) && from && to){
      setLoading(false);
    } else {
      setLoading(true);
    }
  };
  const updateDuration = (newDurationValue, isRangeSelected) => {
    setStartDate(newDurationValue[0]);
    setEndDate(newDurationValue[1]);
    isRange.current = isRangeSelected;
    updateLoading(factory, machine, shift, newDurationValue[0], newDurationValue[1]);
  };
 return (
    <div className="cv-pick-and-place">
      <h4>{t("LT_machine_dashboard_pick_place")}</h4>
      <FactoryFilter machineType="3" showMachines="true" 
        onFactoryChange={updateFactory} onMachineChange={updateMachine} 
        onDurationChange={updateDuration} onShiftChange={updateShift}>
      </FactoryFilter>
      <br />
      {(machine?.machinename && !loading) && 
        <div className="cv-pick-and-place-content">
          <div className="cv-pnp-widget-wrapper bgcolor2">
            <PnpMachineDowntime selectedMachineName={machine?.machinename} factory={factory} shift={shift} 
              from={startDate.valueOf()} to={endDate.valueOf()} rangeSelected={isRange.current}/>
          </div>
          <div className="cv-pnp-widget-wrapper bgcolor2">
            <PnpMachineSpoilage selectedMachineName={machine?.machinename} factory={factory} shift={shift}
              from={startDate.valueOf()} to={endDate.valueOf()} rangeSelected={isRange.current}/>
          </div>
          <div  className="cv-pnp-widget-wrapper bgcolor2">
            <PnpProductionCount selectedMachineName={machine?.machinename} factory={factory} shift={shift}
              from={startDate.valueOf()} to={endDate.valueOf()} rangeSelected={isRange.current}/>
          </div>
          <div className="cv-pnp-widget-wrapper bgcolor2">
            <PnpMachineStatus selectedMachineName={machine?.machinename} factory={factory} shift={shift}
              from={startDate.valueOf()} to={endDate.valueOf()} rangeSelected={isRange.current}/>
          </div>
        </div>
      }
    </div>
  );
};

export default PickAndPlace;
